window.SOIL_ANALYSIS_VARIANT_ID = "54100544717126";
window.LINK_TO_PLAN_SELECTION = "?view=checkout-plan-selection";
window.LINK_TO_ADD_ON_SELECTION = "?view=checkout-add-on-selection";

window.setCheckoutButtonLoading = ({ isLoading, id = "checkout-button" }) => {
  const button = document.getElementById(id);
  if (!button) return;
  if (isLoading) {
    button.classList.add("no-interaction");
  } else {
    button.classList.remove("no-interaction");
  }
};

let fetchedCart = null;

window.fetchCart = async ({ forceFetch = false } = {}) => {
  if (!fetchedCart || forceFetch) {
    console.log("no cart yet, fetching...");
    fetchedCart = await window.fetchWithRetry("/cart.js");
  }
  console.log("return existing cart");
  return fetchedCart;
};

window.addToCart = async (items) => {
  const itemsArray = Array.isArray(items) ? items : [items];
  const quiz_id = window.getAllHalmsProperty("quiz_id")?.value;
  const fwgp = window.getAllHalmsProperty(
    "fertilizer_with_grass_protection",
  )?.value;
  const fis = window.getAllHalmsProperty("fertilized_in_spring")?.value;
  const fim = window.getAllHalmsProperty("fertilized_in_summer")?.value;

  try {
    const cart = await fetchCart();
    const payload = itemsArray
      .map(({ variantId, sellingPlanId, addProperties = false }) => ({
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: addProperties
          ? {
              _quiz_id: quiz_id,
              _fertilizer_with_grass_protection: fwgp,
              _fertilized_in_spring: fis,
              _fertilized_in_summer: fim,
            }
          : undefined,
      }))
      .filter((item) => {
        const itemAlreadyInCart = cart.items.some(
          // item id in cart is a number
          (cartItem) => String(cartItem.id) === String(item.id),
        );
        return !itemAlreadyInCart;
      });
    if (payload.length > 0) {
      // Item not in cart, proceed to add
      const response = await window.fetchWithRetry("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: payload }),
      });
      console.log({ response });
    }
  } catch (error) {
    console.error(error);
  }
};

window.updateQuanityInCart = async ({ variantId, quantity }) => {
  try {
    await window.fetchWithRetry("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity,
      }),
    });
  } catch (error) {
    console.error(error);
  }
};

window.removeFromCart = async (variantId) => {
  try {
    await window.fetchWithRetry("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    });
  } catch (error) {
    console.error(error);
  }
};

window.removeMultipleFromCart = async (variantIds) => {
  try {
    const updates = variantIds.reduce((acc, variantId) => {
      acc[variantId] = 0; // Set quantity to 0 to remove the item
      return acc;
    }, {});

    await window.fetchWithRetry("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
  } catch (error) {
    console.error(error);
  }
};

window.fetchVariantInCart = async () => {
  const cart = await fetchCart();
  return window.lawnCareData.variants.find((variant) =>
    cart.items.some((item) => String(item.id) === variant.id),
  );
};

window.parsePriceStringToCents = (priceString) => {
  const normalizedPriceString = priceString
    .replace(/[^\d,.-]/g, "")
    .replace(",", ".");
  return Math.round(parseFloat(normalizedPriceString) * 100);
};

window.formatCentsAsPriceString = (cents) => {
  return (cents / 100).toFixed(2).replace(".", ",") + " €";
};

window.mapTitleToPackage = (title) => {
  if (title.includes("Reparieren & Wachsen")) {
    return "UPGRADE_SMALL";
  } else if (title.includes("Stärken & Schützen")) {
    return "UPGRADE_LARGE";
  } else {
    return "UPGRADE_NONE";
  }
};

window.updateTotalPriceInCheckoutButton = (newTotalAmountPriceString) => {
  document
    .querySelectorAll(
      ".checkout-total-amount-button .checkout-button__price-total-today",
    )
    .forEach((element) => {
      element.textContent = newTotalAmountPriceString;
    });
};

window.updatePricePerBoxInCheckoutButton = (selectedVariantPriceString) => {
  document
    .querySelectorAll(
      ".checkout-total-amount-button .checkout-button__price-per-box",
    )
    .forEach((element) => {
      element.textContent = `danach ${selectedVariantPriceString} pro Pflegebox`;
    });
};
